import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import type { ModalOptions } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { Router } from '@angular/router';
// import { Location } from '@angular/common';

import {
} from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TAddress, TIsoCountry, TCreateAccountInfo, TRegion, TIsoTimezone } from '@shared/models';

@Component({
    'selector': 'app-apply4-quickstart',
    'templateUrl': './apply4QuickStart.page.html',
    'styleUrls': ['./apply4QuickStart.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Apply4QuickStartPage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: any = { 'role': 'manager', 'timezone': {} };
    public submitted = false;

    // private accountCreatorService: AccountCreatorService,
    constructor(injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        super.ngOnInit();
    }

    public override ngOnDestroy() {
        super.ngOnDestroy();
    }
}
